import React, { useEffect, useState } from "react"
import { Link } from "react-router"
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { Modal, Dropdown } from 'react-bootstrap'
import DatePicker from "react-datepicker"
import Select from 'react-select'

import FilterSearch from 'pages/parts/FilterSearch'
import FilterPagination from 'pages/parts/FilterPagination'
import DebtCorrectionModal from 'pages/parts/DebtCorrectionModal'
import DebtorsSmsModal from 'pages/parts/DebtorsSmsModal'
import { hasPermission } from 'helpers/permissions'

import { httpOk, GET, POST, FILE_D } from 'helpers/api'
import {
	formatMoney, regexPhoneNumber, returnSign, formatDate, returnMinDate,
	findKeyFromArrayByValue, PAGE_SIZES, buildCashAccountSelectOptions, getAccountSelectProps, pickCashAccountId
} from 'helpers/helpers'
import { renderSortIndicator } from 'helpers/tableSortIndicator'

function Index() {
	const { t } = useTranslation()

	const reduxAccount = useSelector(state => state.account)
	const date = new Date()

	const [data, setData] = useState([])
	const [poses, setPoses] = useState([])
	const [countries, setCountries] = useState([])
	const [regions, setRegions] = useState([])
	const [districts, setDistricts] = useState([])
	const [accounts, setAccounts] = useState([])
	const [counterparties, setCounterparties] = useState([])
	const [paymentPurposeTypes, setPaymentPurposeTypes] = useState([])
	const [modalPayment, setModalPayment] = useState(false)
	const [correctionItem, setCorrectionItem] = useState(null)
	const [showDebtorsSms, setShowDebtorsSms] = useState(false)
	const [selectedItem, setSelectedItem] = useState({ 'created_at': date })
	const [dropdownIsOpen, setDropdownIsOpen] = useState(false)
	const [filterDataExist, setFilterDataExist] = useState(false)
	const [filterData, setFilterData] = useState({
		'pos_id': reduxAccount.pos_id,
		'size': 20,
		'url': '/report-organizations',
		'response': null
	})

	async function searchWithFilter(nextFilterData = filterData, passedData = {}) {
		var filterUrl = "/report-organizations"
		var urlParams = ""
		const filterDataCopy = { ...nextFilterData }
		checkFilter(filterDataCopy)

		if (filterDataCopy.pos_id)
			urlParams += returnSign(urlParams) + 'pos_id=' + filterDataCopy.pos_id
		if (filterDataCopy.search)
			urlParams += returnSign(urlParams) + 'search=' + filterDataCopy.search
		if (filterDataCopy.country_id)
			urlParams += returnSign(urlParams) + 'country_id=' + filterDataCopy.country_id
		if (filterDataCopy.region_id)
			urlParams += returnSign(urlParams) + 'region_id=' + filterDataCopy.region_id
		if (filterDataCopy.district_id)
			urlParams += returnSign(urlParams) + 'district_id=' + filterDataCopy.district_id
		if (filterDataCopy.order_by)
			urlParams += returnSign(urlParams) + 'order_by=' + filterDataCopy.order_by
		if (filterDataCopy.only_pending)
			urlParams += returnSign(urlParams) + 'only_pending=1'
		if (filterDataCopy.size)
			urlParams += returnSign(urlParams) + 'size=' + filterDataCopy.size
		if (filterDataCopy.page)
			urlParams += returnSign(urlParams) + 'page=' + filterDataCopy.page

		if (passedData['excel']) {
			urlParams += returnSign(urlParams) + 'excel=true'

			const responseExcel = await FILE_D(filterUrl + urlParams)
			if (httpOk(responseExcel)) {
				// Создаем объект Blob из полученного файла
				const file = new Blob([responseExcel.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

				// Создаем ссылку для скачивания файла
				const fileUrl = URL.createObjectURL(file);

				// Создаем ссылку для скачивания файла в браузере
				const link = document.createElement('a');
				link.href = fileUrl;
				link.setAttribute('download', `organizations.xlsx`);
				document.body.appendChild(link);
				link.click();

				// Удаляем ссылку после скачивания файла
				URL.revokeObjectURL(fileUrl);
			}
			return
		}

		if (`/report-organizations${urlParams}` !== filterUrl)
			setFilterDataExist(true)

		filterUrl = filterUrl + urlParams

		const response = await GET(filterUrl, {}, { loader: true })
		if (httpOk(response)) {
			setData(response.data)
			setFilterData({ ...filterDataCopy, 'url': filterUrl, 'response': response.data })
		}

		setDropdownIsOpen(false)
	}

	function parseTableOrderBy(orderBy) {
		if (!orderBy) return { field: null, sort: 'asc' }

		const [field, sort = 'asc'] = String(orderBy).split(',')
		return {
			field,
			sort: sort.toLowerCase() === 'desc' ? 'desc' : 'asc',
		}
	}

	function tableSortState() {
		const { field, sort } = parseTableOrderBy(filterData.order_by)
		return { order_by: field, sort }
	}

	function isDebtLimitExceeded(item) {
		const debtLimit = Number(item?.debt_limit)
		const balance = Number(item?.balance)
		return debtLimit > 0 && balance < 0 && Math.abs(balance) > debtLimit
	}

	// Переключатель "только организации с незавершённым действием" (неподтверждённые оплаты)
	function toggleOnlyPending() {
		const nextFilterData = { ...filterData, 'only_pending': !filterData.only_pending, 'page': null }
		setFilterData(nextFilterData)
		searchWithFilter(nextFilterData)
	}

	function handleTableSort(fieldKey) {
		const { field: currentField, sort: currentSort } = parseTableOrderBy(filterData.order_by)
		const nextSort = currentField === fieldKey ? (currentSort === 'asc' ? 'desc' : 'asc') : 'asc'
		const nextFilterData = {
			...filterData,
			order_by: `${fieldKey},${nextSort}`,
			page: null,
		}

		setFilterData(nextFilterData)
		searchWithFilter(nextFilterData)
	}

	async function createExpense(e) {
		e.preventDefault();

		var response = await POST('/expense-web', selectedItem, { loader: true })

		if (httpOk(response)) {
			toggleModalPayment()
			setSelectedItem({ 'created_at': date })
			searchWithFilter()
		}
	}

	async function handleSelectPPT(option) {
		setSelectedItem({
			...selectedItem,
			'payment_purpose_id': option.id,
			'account_chef_id': pickCashAccountId(accounts, option.account_chef_id),
			'account_core_id': option.account_core_id,
			'counterparty': option.counterparty ?? null,
		})

		if (option.counterparty) getCounterparty(option)
		if (!option.counterparty) setCounterparties([])
	}

	async function getCounterparty(option) {
		var response = await POST('/helper/counterparties-type', {
			'payment_purpose_id': option.id
		}, { loader: true })

		if (httpOk(response)) setCounterparties(response.data)
	}

	function toggleModalPayment(bool = false, item = null) {
		var itemCopy = { ...item }
		// Дату — как из календаря: полный Date уходит в JSON временем по UTC, и после
		// полуночи по Ташкенту (до 05:00) оплата ложилась на вчера, на 5 часов раньше
		itemCopy.created_at = formatDate(new Date(), 'yyyy-MM-dd')

		if (bool) {
			itemCopy.pos_id = reduxAccount.pos_id
			itemCopy.counterparty_id = item.organization_id
		} else {
			itemCopy.amount = ''
			itemCopy.note = null
			itemCopy.counterparty_id = null
		}
		
		setSelectedItem(itemCopy)
		setModalPayment(bool)
	}

	function resetFilter() {
		const nextFilterData = {
			pos_id: reduxAccount.pos_id,
			size: 20,
			search: '',
			page: null,
		}
		setFilterData(nextFilterData)
		searchWithFilter(nextFilterData)
	}

	function checkFilter(currentFilterData = filterData) {
		if (currentFilterData.search === '') {
			setFilterDataExist(false)
		}
	}

	function toggleDropdown() {
		setDropdownIsOpen(!dropdownIsOpen)
	}

	async function paginate(page) {
		const nextFilterData = { ...filterData, 'page': page }
		setFilterData(nextFilterData)
		searchWithFilter(nextFilterData)
	}

	function handlePageSizeChange(size) {
		const nextFilterData = { ...filterData, size, page: null }
		setFilterData(nextFilterData)
		searchWithFilter(nextFilterData)
	}

	async function handleSelectCountry(option) {
		setFilterData({ ...filterData, 'country_id': option ? option.id : null })
		if (option) getRegions(option.id)
	}

	async function handleSelectRegion(option) {
		setFilterData({ ...filterData, 'region_id': option ? option.id : null })
		if (option) getDistricts(option.id)
	}

	async function handleSelectDistrict(option) {
		setFilterData({ ...filterData, 'district_id': option ? option.id : null })
	}

	async function getPoses() {
		const response = await GET('/helper/poses')
		if (httpOk(response)) setPoses(response.data)
	}

	async function getPaymentPurposeTypes() {
		const response = await GET('/helper/ppt-income?counterparty=organization')
		if (httpOk(response)) setPaymentPurposeTypes(response.data)
	}

	async function getAccounts() {
		const response = await GET('/helper/accounts')
		if (httpOk(response)) setAccounts(response.data)
	}

	async function getCountries() {
		const response = await GET('/helper/countries')
		if (httpOk(response)) setCountries(response.data)
	}

	async function getRegions(country_id) {
		const response = await GET(`/helper/regions/${country_id}`)
		if (httpOk(response)) setRegions(response.data)
	}

	async function getDistricts(region_id) {
		const response = await GET(`/helper/districts/${region_id}`)
		if (httpOk(response)) setDistricts(response.data)
	}

	useEffect(() => {
		getPoses()
		getCountries()
		getAccounts()
		getPaymentPurposeTypes()
		searchWithFilter()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	const accountChefOptions = buildCashAccountSelectOptions(accounts)

	return (
		<>
			<div className="page-header d-flex justify-content-between">
				<h4 className="vertical-center h-100">
					{t('organizations')} [{data?.total}]
				</h4>
				{hasPermission('sending_sms') &&
					<button className="btn-rounded btn btn-outline-primary" onClick={() => setShowDebtorsSms(true)}>
						<i className="uil-comment-alt-message me-1" />{t('sms_debtors_button')}
					</button>
				}
			</div>

			<DebtorsSmsModal
				show={showDebtorsSms}
				onHide={() => setShowDebtorsSms(false)}
				counterparty="organization"
				posId={filterData.pos_id || reduxAccount.pos_id}
			/>

			<div className="card">
				<div className="card-body">
					<div className="d-flex justify-content-between flex-wrap mb-3">
						<div className="d-flex gap-2">
							<FilterSearch
								filterData={filterData}
								setFilterData={setFilterData}
								onSearchChange={(search) => {
									const nextFilterData = { ...filterData, search, page: null }
									setFilterData(nextFilterData)
									searchWithFilter(nextFilterData)
								}}>
							</FilterSearch>
							{data?.pending_total > 0 &&
								<button
									className={`btn h-100 text-nowrap ${filterData.only_pending ? 'btn-danger' : 'btn-outline-danger'}`}
									onClick={() => toggleOnlyPending()}
									title={t('pending_payments_hint')}>
									<i className="uil uil-bell me-1"></i>
									{t('pending_payments')} [{data.pending_total}]
								</button>
							}
							<Dropdown onToggle={toggleDropdown} show={dropdownIsOpen}>
								<Dropdown.Toggle variant="outline-primary" className="btn-wide h-100">
									{t('filter')}
								</Dropdown.Toggle>

								<Dropdown.Menu className="dropdown-filter">
									<div className="row">
										<div className="form-group col-md-6">
											<label>{t('pos')}</label>
											<Select
												options={poses}
												value={poses.find(option => option.id === filterData.pos_id) || ''}
												onChange={(option) => setFilterData({ ...filterData, 'pos_id': option.id })}
												placeholder=""
												noOptionsMessage={() => t('list_empty')}
												getOptionLabel={(option) => option.name}
												getOptionValue={(option) => option.id}
											/>
										</div>
									</div>
									<div className="row">
										<div className="col-md-4">
											<div className="form-group">
												<label>{t('countries')}</label>
												<Select
													isClearable
													options={countries}
													value={countries.find(option => option.id === filterData.country_id) || ''}
													onChange={(option) => handleSelectCountry(option)}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
										</div>
										<div className="col-md-4">
											<div className="form-group">
												<label>{t('regions')}</label>
												<Select
													isClearable
													options={regions}
													value={regions.find(option => option.id === filterData.region_id) || ''}
													onChange={(option) => handleSelectRegion(option)}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
										</div>
										<div className="col-md-4">
											<div className="form-group">
												<label>{t('districts')}</label>
												<Select
													isClearable
													options={districts}
													value={districts.find(option => option.id === filterData.district_id) || ''}
													onChange={(option) => handleSelectDistrict(option)}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
										</div>
									</div>
									<div className="row mt-3">
										<div className="col-md-12">
											<div className="d-flex justify-content-end gap-2">
												<button className="btn btn-secondary"
													onClick={() => setDropdownIsOpen(false)}>
													{t('cancel')}
												</button>
												<button className="btn btn-primary"
													onClick={() => searchWithFilter({ ...filterData, page: null })}>
													{t('apply')}
												</button>
											</div>
										</div>
									</div>
								</Dropdown.Menu>
							</Dropdown>
							<button className="btn btn-outline-primary btn-wide-2"
								onClick={() => searchWithFilter(filterData, { 'excel': true })}>
								<i className="uil uil-file-download-alt"></i>
							</button>
						</div>
						<div className="d-flex gap-2">
							<div className="vertical-center">
								<h4><b>{t('amount')}</b>:</h4>
							</div>
							<div className="vertical-center">
								<h5 className="text-end">
									<span className={`${data.total_amount >= 0 ? 'text-success' : 'text-danger'}`}>
										{formatMoney(data.total_amount)}
									</span>
								</h5>
							</div>
						</div>
					</div>

					{filterDataExist &&
						<div className="filter-block">
							<div className="filter">
								<strong>{t('filter')}</strong>
								<br />
								{filterData.pos_id &&
									<span className="me-2">
										<b>{t('pos')}: </b>
										{findKeyFromArrayByValue(poses, 'id', filterData.pos_id, 'name')}
									</span>
								}
								{filterData.region_id &&
									<span className="me-2">
										<b>{t('region')}: </b>
										{findKeyFromArrayByValue(regions, 'id', filterData.region_id, 'name')}
									</span>
								}
								{filterData.district_id &&
									<span className="me-2">
										<b>{t('district')}: </b>
										{findKeyFromArrayByValue(districts, 'id', filterData.district_id, 'name')}
									</span>
								}
								{filterData.search &&
									<span className="me-2">
										<b>{t('search')}: </b>
										<span>{filterData.search}</span>
									</span>
								}
							</div>
							<div className="vertical-center">
								<button className="btn btn-outline-dark text-uppercase" onClick={resetFilter}>
									{t('reset')}
								</button>
							</div>
						</div>
					}

					<div className="table-responsive">
						<table className="table table-bordered table-hover mb-0">
							<thead>
								<tr>
									<th style={{ width: '33px', minWidth: '33px', maxWidth: '33px' }} className="text-center">#</th>
									<th
										style={{ 'width': '15%' }}
										className="th-sortable user-select-none"
										onClick={() => handleTableSort('name')}
										title={t('sort_by')}>
										<div className="d-flex align-items-center justify-content-between gap-2 pe-1">
											<span>{t('name2')}</span>
											{renderSortIndicator('name', tableSortState())}
										</div>
									</th>
									<th style={{ 'width': '8%' }} className="td-ellipsis">{t('short_name')}</th>
									<th style={{ 'width': '10%' }}>{t("phone")}</th>
									<th style={{ 'width': '8%' }}>{t("tin")}</th>
									<th style={{ 'width': '10%' }}>{t("region")}</th>
									<th style={{ 'width': '10%' }}>{t("district")}</th>
									<th style={{ 'width': '10%' }}>{t("note")}</th>
									<th style={{ 'width': '10%' }} className="td-ellipsis">{t("last_action")}</th>
									<th
										style={{ 'width': '10%' }}
										className="th-sortable user-select-none"
										onClick={() => handleTableSort('last_action')}
										title={t('sort_by')}>
										<div className="text-center">
											<span>{t("action_date")}</span>
											{renderSortIndicator('last_action', tableSortState())}
										</div>
									</th>
									<th style={{ 'width': '10%' }} className="text-end">{t("debt_limit")}</th>
									<th
										style={{ 'width': '10%' }}
										className="text-end th-sortable user-select-none"
										onClick={() => handleTableSort('balance')}
										title={t('sort_by')}>
										<div className="d-flex align-items-center justify-content-end gap-2">
											<span>{t("amount")}</span>
											{renderSortIndicator('balance', tableSortState())}
										</div>
									</th>
									<th style={{ width: '33px', minWidth: '33px', maxWidth: '33px' }}></th>
								</tr>
							</thead>
							<tbody>
								{data?.data?.map((item, index) => (
									<tr className="tr-middle" key={index}>
										<td style={{ width: '33px', minWidth: '33px', maxWidth: '33px' }} className="text-center">{item.row_number}</td>
										<td className="td-ellipsis">
											<Link className="text-primary cursor table-first-column-clickable"
												to={`/report-organizations/debts/${item.organization_id}`}>
												{item.name}
											</Link>
											{item.pending_count > 0 &&
												<Link className="badge bg-danger ms-2 text-white text-decoration-none"
													title={t('pending_payments_hint')}
													to={`/report-organizations/debts/${item.organization_id}?pending=1&pos_id=${filterData.pos_id}`}>
													<i className="uil uil-bell me-1"></i>{item.pending_count}
												</Link>
											}
										</td>
										<td className="td-ellipsis">{item.short_name}</td>
										<td className="text-nowrap">{regexPhoneNumber(item.phone)}</td>
										<td className="td-ellipsis">{item.tin}</td>
										<td className="td-ellipsis">{item.region_name}</td>
										<td className="td-ellipsis">{item.district_name}</td>
										<td className="td-ellipsis">{item.note}</td>
										<td className="text-nowrap">
											{item.last_action_at
												? t(item.last_action_type || "correction")
												: t("no_actions")}
										</td>
										<td className="text-nowrap text-center">
											{item.last_action_at ? formatDate(item.last_action_at) : "—"}
										</td>
										<td
											className={`text-end text-nowrap ${isDebtLimitExceeded(item) ? 'text-danger fw-bold' : ''}`}
											title={isDebtLimitExceeded(item) ? t("debt_limit_exceeded") : ""}>
											{item.debt_limit !== null && item.debt_limit !== undefined
												? formatMoney(item.debt_limit)
												: "—"}
											{isDebtLimitExceeded(item) &&
												<i className="uil uil-exclamation-triangle ms-1"></i>
											}
										</td>
										<td className="text-end text-nowrap">
											<div className={item.balance >= 0 ? 'text-primary' : 'text-danger'}>
												<span>{formatMoney(item.balance)}</span>
											</div>
										</td>
										<td style={{ width: '33px', minWidth: '33px', maxWidth: '33px' }}>
											<div className="table-dropdown">
												<Dropdown id={`dropdown-${index}`}>
													<Dropdown.Toggle variant="outline-primary">
														<i className="uil uil-ellipsis-v"></i>
													</Dropdown.Toggle>

													<Dropdown.Menu>
														<div className="table-dropdown-item"
															onClick={() => toggleModalPayment(true, item)}>
															<i className="uil uil-transaction"></i>
															{t('payment')}
														</div>
														<div className="table-dropdown-item"
															onClick={() => setCorrectionItem(item)}>
															<i className="uil uil-balance-scale"></i>
															{t('debt_correction')}
														</div>
													</Dropdown.Menu>
												</Dropdown>
											</div>
										</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>

					<FilterPagination
						pagination={filterData}
						paginate={paginate}
						showPageSizeSelect
						pageSizeOptions={PAGE_SIZES}
						onPageSizeChange={handlePageSizeChange}>
					</FilterPagination>
				</div>
			</div>

			{/* MODAL PAYMENT */}
			<Modal show={modalPayment} animation={false}
				centered dialogClassName="update-modal-width"
 onHide={() => toggleModalPayment()}>
				<Modal.Header closeButton>
					<Modal.Title>{t('expense')}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={createExpense} autoComplete="off">
						{reduxAccount.role === 'ROLE_OWNER' &&
							<div className="form-group">
								<label>{t('pos')}</label>
								<Select
									options={poses}
									value={poses.find(option => option.id === selectedItem.pos_id)}
									onChange={(option) => setSelectedItem({ ...selectedItem, 'pos_id': option.id })}
									placeholder=""
									noOptionsMessage={() => t('list_empty')}
									getOptionLabel={(option) => option.name}
									getOptionValue={(option) => option.id}
								/>
							</div>
						}
						<div className="form-group">
							<label>{t('date')}</label>
							<div className="calendar-input">
								<DatePicker
									showMonthDropdown
									showYearDropdown
									dropdownMode="select"
									yearDropdownItemNumber={2}
									className="form-control"
									dateFormat="dd.MM.yyyy"
									selected={selectedItem.created_at ? new Date(selectedItem.created_at) : ''}
									onChange={(date) => setSelectedItem({ ...selectedItem, 'created_at': formatDate(date, 'yyyy-MM-dd') })}
									minDate={returnMinDate(new Date(), 20)}
									maxDate={new Date()}
								/>
								<i className="uil uil-calendar-alt"></i>
							</div>
						</div>
						<div className="form-group">
							<label>{t('expense_type')}<span className="required-mark">*</span></label>
							<Select
								isDisabled={selectedItem.update}
								options={paymentPurposeTypes}
								value={paymentPurposeTypes.find(option => option.id === selectedItem.payment_purpose_id)}
								onChange={(option) => handleSelectPPT(option)}
								placeholder=""
								noOptionsMessage={() => t('list_empty')}
								getOptionLabel={(option) => option.name}
								getOptionValue={(option) => option.id}
							/>
						</div>
						<div className="form-group">
							<label>{t('counterparty')}<span className="required-mark">*</span></label>
							<Select
								isDisabled
								options={counterparties}
								value={counterparties.find(option => option.id && option.id === selectedItem.counterparty_id) || null}
								onChange={(option) => setSelectedItem({ ...selectedItem, 'counterparty_id': option ? option.id : null })}
								placeholder=""
								noOptionsMessage={() => t('list_empty')}
								getOptionLabel={(option) => option.name}
								getOptionValue={(option) => option.id}
							/>
						</div>
						<div className="form-group">
							<label>{t('operation_account')}<span className="required-mark">*</span></label>
							<Select
								isClearable
								{...getAccountSelectProps(t)}
								options={accountChefOptions}
								value={accountChefOptions.find(option => option.id === selectedItem.account_chef_id) || null}
								onChange={(option) => setSelectedItem({ ...selectedItem, 'account_chef_id': option ? option.id : null })}
							/>
						</div>
						<div className="form-group d-none">
							<label>{t('report_account')}</label>
							<Select
								options={accounts}
								value={accounts.find(option => option.id === selectedItem.account_core_id)}
								onChange={(option) => setSelectedItem({ ...selectedItem, 'account_core_id': option ? option.id : null })}
								placeholder=""
								noOptionsMessage={() => t('list_empty')}
								getOptionLabel={(option) => option.name}
								getOptionValue={(option) => option.id}
							/>
						</div>
						<div className="form-group">
							<label>{t('amount')}<span className="required-mark">*</span></label>
							<input type="text" className="form-control" name="amount"
								value={selectedItem.amount ? formatMoney(selectedItem.amount) : ''}
								onChange={(e) => setSelectedItem({ ...selectedItem, 'amount': e.target.value.replace(/[^0-9.]/g, '') })} />
						</div>
						<div className="form-group">
							<label>{t('note')}</label>
							<input type="text" className="form-control" name="note"
								value={selectedItem.note ?? ''}
								onChange={(e) => setSelectedItem({ ...selectedItem, 'note': e.target.value })} />
						</div>
						<div className="d-flex w-100 mt-3 gap-2">
							<button type="button" className="btn btn-outline-warning w-100"
								onClick={() => toggleModalPayment()} tabIndex="-1">
								{t('cancel')}
							</button>
							{selectedItem.id ?
								<button type="submit" className="btn btn-primary w-100"
									disabled={!selectedItem.amount}>
									{t('save')}
								</button>
								:
								<button type="submit" className="btn btn-primary w-100">
									{t('save')}
								</button>
							}
						</div>
					</form>
				</Modal.Body>
			</Modal>
			{/* MODAL PAYMENT */}

			<DebtCorrectionModal
				show={!!correctionItem}
				onHide={() => setCorrectionItem(null)}
				onSuccess={() => searchWithFilter()}
				counterparty="organization"
				item={correctionItem || {}}
				posId={filterData.pos_id || reduxAccount.pos_id} />
		</>
	)
}

export default Index
